import { render, staticRenderFns } from "./MultiselectComponent.vue?vue&type=template&id=e4b61008&"
import script from "./MultiselectComponent.vue?vue&type=script&lang=js&"
export * from "./MultiselectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports